export default __webpack_public_path__ + "static/media/printers.470c5719.jpeg";